import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ModalController, ToastController } from '@ionic/angular';
//import { TranslateService } from '@ngx-translate/core';
import { ISeatInfo } from '../../services/order.service';
import { IStore } from '../../services/store.service';
import { StoreSeatsService } from '../../services/store-seats.service';
import { TranslationService } from 'src/app/shared/services/translation.service';

@Component({
    selector: 'app-seats-modal',
    templateUrl: './seats-modal.component.html',
    styleUrls: ['./seats-modal.component.scss'],
    standalone: false
})
export class SeatsModalComponent implements OnInit {
  @Input() store: IStore;

  form: FormGroup;
  showInner: boolean = false;
  seatInfo: ISeatInfo;

  constructor(
    private modalCtrl: ModalController,
    private formBuilder: FormBuilder,
    private storeSeatsService: StoreSeatsService,
    private toastCtrl: ToastController,
    //public translateService: TranslateService
    private translationService: TranslationService
    ) { }

  ngOnInit() { 
    this.form = this.formBuilder.group({
      section: [''],
      row: [''],
      seatNumber: ['']
    });
  }

  onEnter(): any {
    this.showInner = true;
    this.seatInfo = this.form.value;
  }

  onSubmit(): any {
    this.storeSeatsService.verifySeat(this.store.id, this.seatInfo.section, this.seatInfo.row, this.seatInfo.seatNumber).subscribe(async valid => {
      if(valid){
        this.modalCtrl.dismiss(this.form.value);
      } else {
        this.showInner = false;
        const toast = await this.toastCtrl.create({
          message: this.translationService.translate("Seats.InvalidSeat"),
          position: 'bottom',
          buttons: [
            {
              text: this.translationService.translate("General.Close"),
              role: 'cancel',
              handler: () => {
      
              }
            }
          ],
          duration: 4000
        });
        await toast.present();
      }
    });
  }

  cancel() { 
    this.modalCtrl.dismiss(null);
  }
}